import React, { useState, useEffect } from 'react'
import GetAutoSuggestionsForTags from '../Services/Queries/GetAutoSuggestionsForTags'

function AdminTag({
  setSearchListTrue,
  setDesableFilter,
  movieFilterBy,
  handleFilterChange,
  type,
  label,
}) {
  // const [inputValue, setInputValue] = useState('')
  const [selectedTags, setSelectedTags] = useState([])
  const [searchInput, setSearchInput] = useState('')
  const [suggestedTags, setSuggestedTags] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchSuggestions = async () => {
    setLoading(true)
    setError(null)
    if (searchInput.length >= 3) {
      const input = {
        mode: 'Admin',
        contentType: type === 'person' ? 'person' : 'movies',
        search: searchInput,
        from: 0,
        limit: 10,
      }
      if (label === 'Good') {
        input.tagType = 'good'
      } else {
        input.tagType = 'bad'
      }

      try {
        const suggestedTags = await GetAutoSuggestionsForTags(input)
        const sortedTags = suggestedTags.items
          ? suggestedTags.items.sort((a, b) => a.tagURL.localeCompare(b.tagURL))
          : []

        setSuggestedTags(sortedTags)
      } catch (error) {
        console.error(error, 'error')
        setError('Error fetching suggestions')
      } finally {
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    fetchSuggestions()
  }, [searchInput])

  const handleRemoveTag = tag => {
    const updatedTags = selectedTags.filter(t => t !== tag)
    setSelectedTags(updatedTags)
    if (type === 'person') {
      handleFilterChange({
        ...movieFilterBy,
        [label === 'Good' ? 'adminTagsGood' : 'adminTagsBad']: updatedTags,
      })
      setSearchListTrue(false)
      setDesableFilter(false)
    } else {
      handleFilterChange(label === 'Good' ? 'adminTagsGood' : 'adminTagsBad', updatedTags)
    }
  }

  const handleSearchInputChange = e => {
    setSearchInput(e.target.value)
  }

  const handleSuggestionClick = tag => {
    if (!selectedTags.includes(tag)) {
      setSelectedTags([...selectedTags, tag])
      if (type === 'person') {
        const input = {
          ...movieFilterBy,
          [label === 'Good' ? 'adminTagsGood' : 'adminTagsBad']: [...selectedTags, tag],
        }
        // console.log(input, 'input===')
        handleFilterChange(input)
        setSearchListTrue(false)
        setDesableFilter(false)
        setSearchInput('')
        setSuggestedTags([])
      } else {
        handleFilterChange(label === 'Good' ? 'adminTagsGood' : 'adminTagsBad', [
          ...selectedTags,
          tag,
        ])
        setSearchInput('')
        setSuggestedTags([])
      }
    }
  }

  useEffect(() => {
    if (label === 'Good') {
      setSelectedTags(
        movieFilterBy && movieFilterBy.adminTagsGood ? movieFilterBy.adminTagsGood : [],
      )
    } else {
      setSelectedTags(movieFilterBy && movieFilterBy.adminTagsBad ? movieFilterBy.adminTagsBad : [])
    }
  }, [movieFilterBy])

  return (
    <div className='container'>
      <div className='row'>
        <div className='col'>
          <div className='form-group'>
            <label htmlFor='tagInput' style={{ color: 'black' }}>
              {label === 'Good' ? 'what is right?' : 'what is wrong?'}
            </label>
            <div>
              {selectedTags.map(tag => (
                <span key={tag} className='badge badge-primary mr-2 mb-2'>
                  {tag}
                  <button
                    type='button'
                    className='close ml-1'
                    aria-label='Close'
                    onClick={() => handleRemoveTag(tag)}
                  >
                    <span aria-hidden='true'>&times;</span>
                  </button>
                </span>
              ))}
            </div>
          </div>
          <div className='form-group'>
            <input
              type='text'
              className='form-control'
              value={searchInput}
              onChange={handleSearchInputChange}
              placeholder='Search for tags'
            />
          </div>
          {loading && <div>Loading...</div>}
          {error && <div className='text-danger'>{error}</div>}
          <div>
            {suggestedTags.map(tag => (
              <button
                key={tag.tagURL}
                type='button'
                className='btn btn-outline-secondary mr-2 mb-2'
                onClick={() => handleSuggestionClick(tag.tagURL)}
              >
                {tag.tagURL}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminTag
